export default "__VITE_ASSET__36c5bfef__"